import type { ReactNode } from 'react';
import { useSidebarPinState } from '@backstage/core-components';

import styles from './sidebar-control.module.css';

/** @public */
export interface SidebarControlProps {
  /** The controls at the bottom of the drawer, such as the pin toggle. */
  children: ReactNode;
}

/**
 * Fixed control slot at the bottom of the sidebar.
 *
 * @remarks
 * Place it inside a `SidebarGroup`, never around one: core's mobile bottom bar
 * only turns direct `SidebarGroup` children of `Sidebar` into tabs. It never
 * shrinks, so it stays visible while the scroll area above it scrolls. On
 * mobile it renders nothing, because pinning does not exist there.
 *
 * @public
 */
export const SidebarControl = ({ children }: SidebarControlProps) => {
  const { isMobile } = useSidebarPinState();

  if (isMobile) {
    return null;
  }

  return <div className={styles.control}>{children}</div>;
};
